<section>
  <ion-row class="header-row ion-align-items-center">
    <ion-col size>
      <h3 class="popup-heading ml-15">Report Config</h3>
    </ion-col>
    <ion-col size="auto">
      <button mat-icon-button mat-dialog-close class="close-btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </ion-col>
  </ion-row>

  <mat-dialog-content>
    <div class="mb-10">
      <label class="text-color">Grade</label>
      <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style" [placeholder]="'Select Grade'" appendTo="body" [settings]="dropdownSettings" [data]="gradeList" [(ngModel)]="selectGrade" (onSelect)="onSelectGrade()" (onDeSelect)="onDeSelectGrade()" (onSelectAll)="onSelectAllGrade()" (onDeSelectAll)="onDeSelectAllGrade()"></ng-multiselect-dropdown>
    </div>

    <div class="mb-20">
      <label class="text-color">Employee</label>
      <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style" [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="employeeList" [(ngModel)]="selectedEmployee" (onSelect)="onSelectEmployee()" (onDeSelect)="onDeSelectEmployee()" (onSelectAll)="onSelectAllEmployee()" (onDeSelectAll)="onDeSelectAllEmployee()"></ng-multiselect-dropdown>
    </div>

    <button type="button" class="add_btn fs-14 fs_12ForMobile mb-10" [style.background-color]="buttonColorName" (click)="saveReportConfig()">Save</button>
  </mat-dialog-content>
</section>
